/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const CoBuyListPage = lazyLoad(
  () => import('./index'),
  module => module.CoBuyListPage
);
